import { identity } from 'lodash';
import React from 'react';
import Link from '../Link';
import styles from './SocialMenu.module.scss';
import { useEventSettings } from '../../../data/hooks/events/useEventSettings';

function SocialMenu(props) {
    const { linkedin, twitter, facebook, instagram, youtube, info, style } = props,
        { twitter_disabled } = useEventSettings(),
        icons = [
            info ? <Link className="icon social info" href={info} key="info" /> : null,
            linkedin ? <Link className="icon social linkedin" href={linkedin} key="linkedin" /> : null,
            twitter ? <Link className="icon social twitter" href={twitter} key="twitter" /> : null,
            facebook ? <Link className="icon social facebook" href={facebook} key="facebook" /> : null,
            instagram ? <Link className="icon social instagram" href={instagram} key="instagram" /> : null,
            youtube ? <Link className="icon social youtube" href={youtube} key="youtube" /> : null,
        ].filter(identity);

    return icons.length ? (
        <div className={styles.SocialMenu} style={style}>
            {icons}
        </div>
    ) : null;
}

export default SocialMenu;
